<template>
    <button
        type="button"
        class="btn btn-pdv btn-pdv-blue mr-1"
        href="javascript: void(0);"
        :disabled="disabled"
        @click="$emit('onClick')"
    >
        <i class="fe-plus-circle mr-1"></i>
        {{  getI18n('COMMON', 'more_filters') }}
    </button>
</template>

<script>
export default {
    props: {
        disabled: {
            type: Boolean,
            require: false,
        },
    },
}
</script>
